export default __webpack_public_path__ + "static/media/show.e441f91d.svg";